// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as MenuList$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/menu-list/MenuList.bs.js";
import * as PricingDashboardAssetsManager from "../../../assets/PricingDashboardAssetsManager.bs.js";

var ellipsis_button = PricingDashboardAssetsManager.getImage("ellipsis-button.svg");

function buildMenuItems(items) {
  return List.map((function (param) {
                var action_cb = param.action_cb;
                var src = param.img_src;
                var text = param.text;
                return {
                        item_label: {
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return React.createElement(Row$Catalyst.make, {
                                          children: null,
                                          className: "c-action-item"
                                        }, React.createElement("img", {
                                              src: src
                                            }), React.createElement("div", undefined, text));
                            })
                        },
                        item_cb: (function (param) {
                            return Curry._1(action_cb, undefined);
                          })
                      };
              }), items);
}

function CustomActionMenu(Props) {
  var items = Props.items;
  return React.createElement("div", {
              className: "c-custom-action-menu"
            }, React.createElement(MenuList$Catalyst.make, {
                  menuItems: buildMenuItems(items),
                  menu_item_className: "modifications-actions-menu-item",
                  custom_menu_button: React.createElement("img", {
                        src: ellipsis_button
                      })
                }));
}

var make = CustomActionMenu;

export {
  ellipsis_button ,
  buildMenuItems ,
  make ,
  
}
/* ellipsis_button Not a pure module */
